import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_6 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_7 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_8 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_9 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "invalid-feedback" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = { class: "invalid-feedback" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-12" }
const _hoisted_22 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = ["title"]
const _hoisted_25 = ["id", "value"]
const _hoisted_26 = ["for"]
const _hoisted_27 = { class: "" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_30 = {
  key: 1,
  class: "flaticon-plus position-relative ms-5 fs-12",
  style: {"color":"#FFF"}
}

import {ref, onMounted,reactive,inject, watch } from "vue";
import axios from 'axios';
import router from '../../router/index'
import { useI18n } from "vue-i18n";
import {showToast,checkSessionValidate} from "../../utils/function";
import {current_permissions} from '../../utils/permission';
import { useRoute, useRouter } from 'vue-router'
import * as yup from 'yup';
import { Country,Fee,Operator,Organization,TypeFree, Provider, Actions } from "@/utils/Model";
import { getTypeFee } from "../../utils/services";


export default /*@__PURE__*/_defineComponent({
  __name: 'PermissionsAddContent',
  setup(__props) {

const backApi=inject('back');
const page = ref(1);
const total = ref(0);
const pagesLeft = ref(0);
const currentPage = ref(0);
const numPages = ref(0);
const { t } = useI18n();
let edit = 0;
let itemCode = '';
let code:string|null='';
const selectedOrganization = ref(code);
const selectedOperator = ref('');
// const selectedActions = ref([]);
const selectedActions = ref<Actions[]>([]);

const selectedTypeFee = ref('');
const selectedMode = ref('');
const btnLoad = ref(false);

const selectedStatus = ref('');
const selectedPaymentMethod = ref('');
const selectedOperationType = ref('');
const selectedCheckOnlyAfterTimeout = ref(false);
const selectedProvider = ref('');

let countryCode = ''
let countryName = ''


const loader = ref(false);

let token: string|null = localStorage.getItem('login_token');


const countries =ref(new Array<Country>());
const fees =ref(new Array<Fee>());
const organizations =ref(new Array<Organization>());
const operators =ref(new Array<Operator>());
const providers =ref(new Array<Provider>());
// const typefees =ref([]);
const typefees =ref(new Array<TypeFree>());
let operatorsTemp =new Array<Operator>();
let permissionsTemp =new Array<Permissions>();
let permissionsShow =new Array<Permissions>();
// let actionsTemp =new Array<Actions>();
const actionsTemp = ref([]); // 
const actionByPermission = ref<Actions[]>([]);
// const actionByPermission =ref(new Array<Actions>());
  const route = useRoute();
  let codePermission = route.params.id;

  const errors = ref('');  
  const errorId = ref('');  
  const success = ref('');
  const errorsBis = {'name':'', 'description':''};
  const pageLoad = ref(false);

  const formValues = reactive({    
    name: "",
    description: "",
   
  });

  
  const schema = yup.object({    
      name: yup.string().required('Le nom de l\'operateur  est requis'),   
      description: yup.string().required('La description est requis'),   
     
  });

const initField = () =>{
  formValues.name=  ''; 
 
  formValues.description=  ""; 
  
  itemCode = '';
  edit=0;
  
  // selectedActions.value = '' ,

  errorId.value=''
  errors.value=''
}

  function handleOrganizationChange(event) {
      selectedOrganization.value = event.target.value;
    }

function handleOperatorChange(event) {
  selectedOperator.value = event.target.value;
}

function handleTypeFeeChange(event) {
  selectedTypeFee.value = event.target.value;
}

function handleCheckOnlyAfterTimeoutChange(event) {
  selectedCheckOnlyAfterTimeout.value = event.target.value;
}

// function handleCheckOnlyAfterTimeoutChange(event) {
//   selectedCheckOnlyAfterTimeout.value = event.target.value === "1";
// }


function handleModeChange(event) {
  selectedMode.value = event.target.value;
}

function handleStatusChange(event) {
  selectedStatus.value = event.target.value;
}

function handlePaymentMethodChange(event) {
  selectedPaymentMethod.value = event.target.value;
}

function handleOperationTypeChange(event) {
  selectedOperationType.value = event.target.value;
}

function handleProviderChange(event) {
  selectedProvider.value = event.target.value;
}

// function handleActionsChange(event) {
//   // selectedActions.value = event.target.value;
//   var i = 0;
//   while(i<actionsTemp.length){    
//       if(actionsTemp[i].code == event.target.value){         
//           selectedActions.value=actionsTemp[i].code;
//           countryCode = selectedActions.value=actionsTemp[i].code;
//       }      
//       i++;
//   }
//   // operators
//   var j = 0;
//   var operatorArr = new Array<Operator>();
//   while(j<operatorsTemp.length){    
//       if(operatorsTemp[j].countryCode == event.target.value){         
//           operatorArr.push(operatorsTemp[j]);
//       }      
//       j++;
//   }
//    operators.value = operatorArr;
// }

function formatDateFr(value){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate();  
        day = day<10?'0'+day:day;      
        return day+'/'+month+'/'+year;
        
    }
}

const getFees = (arg=1) =>{
    // +arg    
    axios.get(backApi+'/secure/fees/?organization='+code,{    
      headers: {
            
            Authorization: `Bearer ${token}`
      } 
    })
    .then((response) => {        
        fees.value = response.data;  //.data.fees            
        
        // total.value=parseInt(response.data.pagination.total);
        // page.value=parseInt(response.data.pagination.page);
        // pagesLeft.value=parseInt(response.data.pagination.pagesLeft);
        // currentPage.value=parseInt(response.data.pagination.currentPage);
        // numPages.value=parseInt(response.data.pagination.numPages);

        total.value=10;
        page.value=1;
        pagesLeft.value=0;
        currentPage.value=1;
        numPages.value=1;
        
        // alert(total.value)
    }).catch((error) => {
          if( error.response){              
              if(error.response.status === 401){
                router.push('/')
                
              }   
              
          }
  });
}

const getOrganizations = () =>{

axios.get(backApi+'/secure/organizations/',{  
  headers: {
       
        Authorization: `Bearer ${token}`
  } 
})
.then((response) => {
    // users.value = response.data;
    organizations.value = response.data;  //.data.users          
    // console.log(response.data);
    
    
}).catch((error) => {
      if( error.response){
          // console.log(error.response.data); // => the response payload 
          if(error.response.status === 401){
            router.push('/')
            //window.location.href = '/';
            //router.push('/');
          }   
          
      }
});
//  loader.value=true;
}

const getProviders = () =>{

axios.get(backApi+'/secure/providers/',{  
  headers: {
       
        Authorization: `Bearer ${token}`
  } 
})
.then((response) => {
    // users.value = response.data;
    providers.value = response.data;  //.data.users          
    // console.log(response.data);
    
    
}).catch((error) => {
      if( error.response){
          console.log(error.response.data); // => the response payload 
          if(error.response.status === 401){
            router.push('/')
            //window.location.href = '/';
            //router.push('/');
          }   
          
      }
});
//  loader.value=true;
}

const getTypeFees = () =>{

axios.get(backApi+'/secure/typefees/',{  
  headers: {
       
        Authorization: `Bearer ${token}`
  } 
})
.then((response) => {
    // users.value = response.data;
    typefees.value = response.data;  //.data.users          
    // console.log(response.data);
    
    
}).catch((error) => {
      if( error.response){
          // console.log(error.response.data); // => the response payload 
          if(error.response.status === 401){
            router.push('/')
            //window.location.href = '/';
            //router.push('/');
          }   
          
      }
});
//  loader.value=true;
}

const getActions = () =>{

axios.get(backApi+'/secure/actions/',{  
  headers: {
       
        Authorization: `Bearer ${token}`
  } 
})
.then((response) => {
    // actionsTemp = response.data;
    actionsTemp.value = response.data.sort((a, b) => {
      const routeA = a.route ? a.route.toUpperCase() : '';
      const routeB = b.route ? b.route.toUpperCase() : '';
      return routeA.localeCompare(routeB);
    });
     
    
}).catch((error) => {
      if( error.response){
          console.log(error.response.data); // => the response payload 
          if(error.response.status === 401){
            router.push('/')
            //window.location.href = '/';
            //router.push('/');
          }   
          
      }
});
//  loader.value=true;
}

watch(
  [actionsTemp, actionByPermission],
  () => {
    const authorizedRoutes = actionByPermission.value.map(p => p.route);
    selectedActions.value = actionsTemp.value
      .filter(action => authorizedRoutes.includes(action.route))
      .map(action => action.route);
  },
  { immediate: true }
);



const getOperators = () =>{

axios.get(backApi+'/secure/operators/',{  
headers: {
   
    Authorization: `Bearer ${token}`
} 
})
.then((response) => {
operatorsTemp = response.data;  //.data.users          

}).catch((error) => {
  if( error.response){
      console.log(error.response.data); // => the response payload 
      if(error.response.status === 401){
        router.push('/')        
      }   
      
  }
});

}

const getPermissionsId = (codePermission) =>{
  if (codePermission !== 'null') {
    axios.get(backApi+'/secure/permissions/'+codePermission+'/show',{  
        headers: {
            Authorization: `Bearer ${token}`
        } 
        })
        .then((response) => {         
          permissionsShow = response.data;
          actionByPermission.value = response.data.actions
          formValues.description = response.data.description
          formValues.name = response.data.name

        }).catch((error) => {
          if( error.response){
              console.log(error.response.data); // => the response payload 
          }
        });
  }
        
}

const hasActions = (actionCode) => {
  return actionByPermission.value.some(p => p.code === actionCode);
};



const getPermissions = () =>{

axios.get(backApi+'/secure/permissions/',{  
headers: {
   
    Authorization: `Bearer ${token}`
} 
})
.then((response) => {
// permissionsTemp = response.data;  //.data.users          

 permissionsTemp = response.data.sort((a, b) => {
      const nameA = a.name ? a.name.toUpperCase() : '';
      const nameB = b.name ? b.name.toUpperCase() : '';
      return nameA.localeCompare(nameB);
    });
console.log("PERMISSIONS___",permissionsTemp);


}).catch((error) => {
  if( error.response){
      console.log(error.response.data); // => the response payload 
      if(error.response.status === 401){
        router.push('/')        
      }   
      
  }
});

}

const changeStatus =(status,code)=>{
 // alert(code)
  axios.put(`${backApi}/secure/operators/${code}/status`,{
          code: code,
          status:  (status=='ACTIVE')?'INACTIVE':'ACTIVE'
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
      }       
      }).then((response) => {        
        router.go();        
        
    }).catch((error) => {
          if( error.response){
              //console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                
              }   
              
          }
  });
}


const showOperator = (code) =>{
    // +arg
     axios.get(backApi+'/secure/actions/'+code+'/show',{    
      headers: {
            
            Authorization: `Bearer ${token}`
      } 
    })
    .then((response) => {        

        formValues.name = response.data.name;
        formValues.description = response.data.description;

        selectedActions.value = response.data.actions;

        itemCode = response.data.code;


        edit=1;        
        // console.log(response.data);
    }).catch((error) => {
          if( error.response){              
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                console.log(error.response);
              }   
              
          }
  });
}

const save =()=>{
  if (edit==0){
    storePermission()
  }else{
    updatePermission()
  }
  
}

const storePermission =()=>{
try {  
  schema.validateSync(formValues);
  // alert(formValues.name)
  axios.post(`${backApi}/secure/permissions/new`,{          
          name:formValues.name,
          description: formValues.description ,
          actions : selectedActions.value
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
           'Content-Type':'application/json',
      }       
      }).then((response) => {  
        if(response.status === 200){      
          showToast("Permission "+formValues.name.toLowerCase()+" enregistré avec succès","green");
          initField();   
          setTimeout(() => {
            // router.go();  
                router.push('/permissions/add')
          }, 500);
        }      
        
    }).catch((error) => {
      // alert(error.response.data.errorId);
          if( error.response){
              //console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;
              } 
              
          }
  });
} catch (error) {
        // console.log(error);        
         errors.value="une erreur inattendue est apparue"
         
              
}

// name:name.value,
// email:email.value,
// contact:contact.value,
// description:description.value
}

const updatePermission =()=>{
  btnLoad.value=true;
try {  
  schema.validateSync(formValues);
  // alert(formValues)

  axios.put(`${backApi}/secure/permissions/${codePermission}/edit`,{          
          name:formValues.name,
          description:formValues.description,
          actions : selectedActions.value
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
          //  'Content-Type':'application/json',
      }       
      }).then((response) => {            
        btnLoad.value=false;
        if(response.status === 200){   
          showToast("Modification effectuée avec succès","green");            
          // router.go();  
        }      
        
    }).catch((error) => {
      btnLoad.value=false;
      // alert(error.response.data.errorId);
          if( error.response){
              //console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;
              } 
              
          }
  });
} catch (error) {
        // console.log(error);        
         errors.value="une erreur inattendue est apparue"
         btnLoad.value=false;       
              
}

}

function validate(field) {
      schema
        .validateAt(field, formValues)
        .then(() => {
          errorsBis[field] = "";
        })
        .catch(err => {
          errorsBis[field] = err.message;          
        });
        errors.value=''
}


 onMounted(async () => { 
  checkSessionValidate(1)
 
  //  code = route.params.id;
  //  getFees();
   getOperators();
   getPermissions()
   getProviders()
   getOrganizations();
  //  getTypeFees();
   getActions();
   getPermissionsId(codePermission);

   if (codePermission == 'null') {
    edit = 0 
   } else {
    edit = 1
   }
 
   setTimeout(function () {
    pageLoad.value=true; 
         },1000)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }, null, -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("form", {
              onSubmit: _withModifiers(save, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_4, [
                (errors.value!=='')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("h6", _hoisted_6, _toDisplayString(errorId.value), 1),
                      _createElementVNode("h6", _hoisted_7, _toDisplayString(errors.value), 1)
                    ]))
                  : _createCommentVNode("", true),
                (success.value!=='')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("h6", _hoisted_9, _toDisplayString(success.value), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('permissionsAdd.permission')), 1),
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formValues.name) = $event)),
                          type: "text",
                          class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['name'] }]),
                          id: "lead-calendar",
                          placeholder: _ctx.$t('permissionsAdd.namePlaceholder'),
                          onBlur: _cache[1] || (_cache[1] = ($event: any) => (validate('name'))),
                          onKeyup: _cache[2] || (_cache[2] = ($event: any) => (validate('name')))
                        }, null, 42, _hoisted_14), [
                          [_vModelText, formValues.name]
                        ]),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(errorsBis['name']), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('permissionsAdd.description')), 1),
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formValues.description) = $event)),
                          type: "text",
                          class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['description'] }]),
                          id: "lead-calendar",
                          placeholder: _ctx.$t('permissionsAdd.descriptionPlaceholder'),
                          onBlur: _cache[4] || (_cache[4] = ($event: any) => (validate('description'))),
                          onKeyup: _cache[5] || (_cache[5] = ($event: any) => (validate('description')))
                        }, null, 42, _hoisted_18), [
                          [_vModelText, formValues.description]
                        ]),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(errorsBis['description']), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('permissionsAdd.actions')), 1),
                      _createElementVNode("div", _hoisted_23, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actionsTemp.value, (action) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: action.code,
                            class: "form-check mb-2 col-md-4",
                            title: action.description
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              id: 'action-' + action.code,
                              value: action.route,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedActions).value = $event))
                            }, null, 8, _hoisted_25), [
                              [_vModelCheckbox, selectedActions.value]
                            ]),
                            _createElementVNode("label", {
                              class: "form-check-label text-black",
                              for: 'action-' + action.code
                            }, _toDisplayString(action.route), 9, _hoisted_26)
                          ], 8, _hoisted_24))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                (_unref(current_permissions)('create_operator', 'edit_operator'))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "submit",
                      class: "btn text-white",
                      style: {"background-color":"#EB9355"},
                      disabled: btnLoad.value
                    }, [
                      (btnLoad.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29))
                        : _createCommentVNode("", true),
                      (!btnLoad.value)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_30))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_unref(edit) == 0 ? _ctx.$t('permissionsAdd.save') : _ctx.$t('permissionsAdd.edit')), 1)
                    ], 8, _hoisted_28))
                  : _createCommentVNode("", true)
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    _cache[9] || (_cache[9] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})